import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaUpsellSectionDefaultVariants = {
  "direction": "column"
}
const aromaUpsellSectionCompoundVariants = []

const aromaUpsellSectionSlotNames = [
  [
    "root",
    "aroma-upsell-section__root"
  ],
  [
    "content",
    "aroma-upsell-section__content"
  ],
  [
    "heading",
    "aroma-upsell-section__heading"
  ],
  [
    "motivation",
    "aroma-upsell-section__motivation"
  ],
  [
    "direction",
    "aroma-upsell-section__direction"
  ],
  [
    "image",
    "aroma-upsell-section__image"
  ]
]
const aromaUpsellSectionSlotFns = /* @__PURE__ */ aromaUpsellSectionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaUpsellSectionDefaultVariants, getSlotCompoundVariant(aromaUpsellSectionCompoundVariants, slotName))])

const aromaUpsellSectionFn = memo((props = {}) => {
  return Object.fromEntries(aromaUpsellSectionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaUpsellSectionVariantKeys = [
  "direction"
]
const getVariantProps = (variants) => ({ ...aromaUpsellSectionDefaultVariants, ...compact(variants) })

export const aromaUpsellSection = /* @__PURE__ */ Object.assign(aromaUpsellSectionFn, {
  __recipe__: false,
  __name__: 'aromaUpsellSection',
  raw: (props) => props,
  variantKeys: aromaUpsellSectionVariantKeys,
  variantMap: {
  "direction": [
    "column",
    "column-reverse",
    "row",
    "row-reverse"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, aromaUpsellSectionVariantKeys)
  },
  getVariantProps
})